/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import styled, { css } from 'styled-components';
import { Label } from '../../../Label';
import { Select } from '../../../Select';
import { visual } from '../../strings';
const generateSortValue = (columns) => {
    const selectedCol = columns.find(col => col.isSorted);
    return selectedCol
        ? JSON.stringify({
            id: selectedCol.id,
            isSortedDesc: selectedCol.isSortedDesc,
        })
        : '';
};
const StyledSelect = styled(Select)(({ theme: { space } }) => css `
    margin-bottom: ${space.md};
  `);
const SortSelect = ({ tableInstance: { toggleSortBy, columns }, handleManualSort, getSortOptionsCardListHeader = visual.getSortOptionsCardListHeader, }) => {
    const { current: selectId } = useRef(`sort-select-${uuid()}`);
    const [value, setValue] = React.useState(generateSortValue(columns));
    const selectOptions = useMemo(() => getSortOptionsCardListHeader(columns, 'ascending', 'descending'), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columns]);
    const handleOnChange = (e) => {
        const safeValue = e.target.value
            .length
            ? JSON.parse(e.target.value)
            : { id: '', isSortedDesc: false };
        const { id, isSortedDesc } = safeValue;
        if (id.length) {
            setValue(e.target.value);
            toggleSortBy(id, isSortedDesc, false);
            handleManualSort === null || handleManualSort === void 0 ? void 0 : handleManualSort({ id, isSortedDesc });
        }
    };
    return columns.some(col => col.isSortable) ? (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: selectId }, "Sort by"),
        React.createElement(StyledSelect, { variant: "single", id: selectId, options: selectOptions, value: value, onChange: handleOnChange }))) : (React.createElement(React.Fragment, null));
};
export { SortSelect };
//# sourceMappingURL=SortSelect.js.map